import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * 
 */
@Injectable({
  providedIn: 'root'
})
export class RouteChildrenEmitterService {

  private selectedRowsSubject = new Subject<{ segment_id: number, iteration_id: number }[]>();

  constructor() { }

  emit(rows: { segment_id: number, iteration_id: number }[]) {
    this.selectedRowsSubject.next(rows);
  }

  getObservable() {
    return this.selectedRowsSubject.asObservable();
  }
}
